import { Link as NbLink } from 'native-base';

import { addWithConfig } from '../../utils';

export const Link = NbLink;

/**
 * @deprecated nativabase component deprecated, use <Typography  instead
 */
export default addWithConfig(Link);
